import ImageCard from "../../atoms/ImageCard";
import { useEffect, useState } from "react";
import Button from "../../atoms/Button";
import { ProjectDescription } from "../../../utils/labels/projectDescription";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AcceptPopUp from "../AcceptPopUp";
import {
  addToWishlist,
  removeFromWishlist
} from "../../../redux/slices/wishlist-slice";
import { addWishlist } from "../../../utils/API/addToWishlist";
import { deleteWishlistItem } from "../../../utils/API/deleteWishlist";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { Tooltip } from "antd";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";

import NotBidNotificationDialog from "../HomePageDialogs/NotBidNotificationDialog";
import ViewSdgContribution from "../../atoms/ViewSdgContribution";
const ProjectCard = ({
  _id,
  userTitle,
  blockchain_detail,
  projectTitle,
  projectLocation,
  credits,
  type,
  tokenType,
  creditTransaction,
  projectImage,
  creditListed,
  OGscore,
  registry,
  totalCredits,
  projectCategory,
  about_project = "",
  project_impact_and_benefits = "",
  holdingsId,
  isListed,
  InquireHandler,
  SDG_contribution=[]
}) => {
  const registryName = registry?.registryName;
  const localRegistryImage = getRegistryImage(registryName);
  let { paraOne, paraTwo, paraThree, paraFour, paraFive, paraSix, paraSeven } =
    ProjectDescription;
  const [searchParams, setSearchParams] = useSearchParams();
    const [bidNotNotificationDialogState, setBidNotNotificationDialogState ] = useState(false);
  
  const dispatch = useDispatch();
  const projectId = searchParams.get("projectId") || "";
  const userId = searchParams.get("userId") || "";
  // const inquire = searchParams.get("inquire") || "false";
  const { userType } = useSelector((state) => state.authReducer);
  const [isWishlistClicked, setIsWishlistClicked] = useState(false);
  const [userNotFoundDailog, SetUserNOtFoundDailog] = useState(false);
  // Use useLocation to access the current URL
  const location = useLocation();

  // Create a function to get query parameters
  const getQueryParams = (param) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(param);
  };

  // Get the inquire parameter from the URL
  const inquire = getQueryParams("inquire");
  const navigate = useNavigate();
  const onBidClick = (e) => {



   


    e.preventDefault();
    e.stopPropagation();

    if (!userType) {
      SetUserNOtFoundDailog(true);
    } else if (
      userType === "trader" &&
      (type === "retireable" || type === "non-transferable")
    ) {
      setBidNotNotificationDialogState(true);
    }else {
      navigate(`/bid?projectId=${projectId}&userId=${userId}`);
    }
  };
  const onInquireClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const formData = {
      projectId: projectId,
      creditOwner: userId
    };
    // console.log("onInquireClick formData:", formData);
    InquireHandler(formData);
  };
  const wishlist = useSelector((state) => state.wishlist);

  useEffect(() => {
    // console.log("wish", wishlist);
    if (wishlist) {
      const isProjectInWishlist = wishlist.find(
        (item) =>
          item.holdingsId === _id && item.is_enquire_required !== isListed
      );
      setIsWishlistClicked(isProjectInWishlist);
    }
  }, [wishlist, _id]);

  const handleVerifyClick = () => {
    if (blockchain_detail) {
      window.open(
        `https://explorer.solana.com/tx/${blockchain_detail.transaction_signature}?cluster=mainnet-beta`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      toast.error("BlockChain Details Not Found");
    }
  };

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userType) {
      SetUserNOtFoundDailog(true);
      return;
    }

    if (isWishlistClicked) {
      handleRemoveFromWishlist();
    } else {
      try {
        const additionalParams = { holdingsId: _id, credit_owner: userId };
        if (isListed) {
          additionalParams.is_enquire_required = false;
        } else {
          additionalParams.is_enquire_required = true;
        }
        const result = await addWishlist(additionalParams, dispatch);
        if (result.success) {
          dispatch(addToWishlist(result.data));
          setIsWishlistClicked(result.data);
        } else {
          console.error("Failed to add to wishlist:", result.message);
        }
      } catch (error) {
        console.error("Error adding project to wishlist:", error);
      }
    }
  };

  const handleRemoveFromWishlist = async () => {
    try {
      await deleteWishlistItem(isWishlistClicked._id, dispatch);
      dispatch(removeFromWishlist({ id: isWishlistClicked._id }));
      setIsWishlistClicked(null);
    } catch (error) {
      console.error("Failed to delete wishlist item:", error);
    }
  };
  return (
    <div className=" w-full flex mt-5">
      <div className="">
        <div className="ml-1 my-1 relative">
          <ImageCard
            iconDisplay="flex"
            classnames="w-[51rem] 2xl:w-[51rem] md:w-[700px] h-[24.875rem] bg-cover rounded "
            userImage={projectImage}
          />
          <div
            className="absolute top-[0px] right-[0px]  w-60  bg-white h-8 rounded-bl-md text-base flex gap-1 cursor-pointer"
            onClick={handleVerifyClick}
          >
            <p className=" text-blue-800 font-bold pl-8 py-1">
              Verify on BlockChain
            </p>
            <svg
              class="h-6 w-6 mt-1 text-blue-800"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              {" "}
              <path stroke="none" d="M0 0h24v24H0z" />{" "}
              <line x1="17" y1="7" x2="7" y2="17" />{" "}
              <polyline points="8 7 17 7 17 16" />
            </svg>
          </div>
          <div className="absolute bottom-[0px] left-[0px] bg-white rounded-tr-lg">
            {tokenType === "Gold" && (
              <img
                src="images/GoldTokens.png"
                alt="Gold Token"
                style={{ width: "55px", height: "55px" }}
              />
            )}
            {tokenType === "Silver" && (
              <img
                src="images/SilverTokens.png"
                alt="Silver Token"
                style={{ width: "55px", height: "55px" }}
              />
            )}
            {tokenType === "Bronze" && (
              <img
                src="images/BronzeTokens.png"
                alt="Bronze Token"
                style={{ width: "55px", height: "55px" }}
              />
            )}
          </div>
        </div>
        <div className=" mt-5">
          <div className="capitalize text-xs font-normal pb-3">{userTitle}</div>
        </div>

        <div className="flex justify-between ">
          <h1 className="text-[1.5rem] font-bold ">{projectTitle}</h1>

          <div
            className="w-32 h-11 bg-no-repeat"
            style={{
              background: `top / contain no-repeat url(${localRegistryImage})`
            }}
          ></div>
          <h3 className="text-lg text-blue-800 font-bold">{projectCategory}</h3>
          <div className="mr-4">
            {!isWishlistClicked ? (
              <img
                src="images/wishlist.svg"
                alt="wishlist-icon"
                className="w-6 h-6"
                onClick={handleWishlistClick}
              />
            ) : (
              <img
                src="images/checkedWishlist.svg"
                alt="checked-wishlist-icon"
                className="w-6 h-6"
                onClick={handleRemoveFromWishlist}
              />
            )}
          </div>
        </div>
        <div className="">
          <h2 className=" pt-[-18px] pb-2 text-[14px] font-normal ">
            {projectLocation}
          </h2>
        </div>
        <div className="flex justify-between">
          <h1 className="text-[15px] capitalize   font-bold text-grey-50">
            {type} | <span> {creditTransaction}</span>
          </h1>

          <h2 className="text-xl font-bold pb-2 mr-6  text-blue-800 ">
            {OGscore}
          </h2>
        </div>
        {inquire === "false" ? (
          <div className="flex flex-col ">
            <h3 className="text-2xl font-bold pb-2">{credits}</h3>
            <Tooltip
              title={
                "Seller has more credit in the holding than listed credits, if you want to buy more click here"
              }
            >
              <div
                className="text-blue-800 text-sm cursor-pointer w-40"
                onClick={onInquireClick}
              >
                More Credits ?
              </div>
            </Tooltip>
          </div>
        ) : (
          <div className="flex flex-col ">
            <h3 className="text-2xl font-bold pb-5  ">{""}</h3>
          </div>
        )}
        <div className="flex justify-between">
          <div className="text-[15px] font-bold text-grey-50">
            Total Credits : {totalCredits}
          </div>

          <div className="mr-6 mt-[-1.5rem]">
            {inquire === "false" ? (
              <h3 className="text-2xl  font-medium ">
                {creditListed}
                <span className="pl-3">
                  <Button
                    varient="primary"
                    borderVarients="blue"
                    className="justify-center px-16 py-5 text-lg text-white  bg-violet"
                    onClick={onBidClick}
                  >
                    Bid
                  </Button>
                </span>
              </h3>
            ) : (
              <span className="pl-3">
                <Button
                  varient="primary"
                  borderColor="none"
                  className="justify-center px-16 py-5 text-lg text-blue-800 bg-blue-300"
                  onClick={onInquireClick}
                >
                  Inquire
                </Button>
              </span>
            )}
          </div>
        </div>

        <div className="w-3/4 ">
          <div className="pt-3 pb-2 text-2xl font-bold">About Project</div>
          <p className=" whitespace-pre-line text-xs font-normal   text-grey-50">
            {about_project}
          </p>
          {/* <p className="text-xs font-normal pt-4 text-grey-50">{paraTwo}</p>
          <p className="text-xs font-normal pt-4 text-grey-50">{paraThree}</p> */}
        </div>
        <div className="w-3/4 whitespace-pre-line">
          <div className="py-8">
          <div className="text-2xl font-bold text-blue-800"> Project impacts and benifits:</div>
          </div>
          <p className="text-xs font-normal  text-grey-50">
            {project_impact_and_benefits}
          </p>
          {/* <p className="text-xs font-normal pt-4 text-grey-50">{paraFive}</p>
          <p className="text-xs font-normal pt-4 text-grey-50">{paraSix}</p>
          <p className="text-xs font-normal pt-4 text-grey-50">{paraSeven}</p> */}
        </div>
        <ViewSdgContribution selected={SDG_contribution} />
      </div>
      <AcceptPopUp
        open={userNotFoundDailog}
        statusType={
          <span className="text-base font-semibold">
            "To buy Carbon credit sign in with buyer or traders account !!"
          </span>
        }
        onCancel={() => SetUserNOtFoundDailog(false)}
        okButtonText={"Log-in/Sign-up"}
        isRequiredCancelButton={false}
      />
      <NotBidNotificationDialog
        open={bidNotNotificationDialogState}
        onCancel={() => setBidNotNotificationDialogState(false)}
      />
    </div>
  );
};
export default ProjectCard;
